export class Prospect {
  constructor(public firstName = "", public lastName = "", public email = "") {}
}
